<template>
  <div class="commodity_details">
    <header>
      <swiper :options="swiperOption" v-if="commoditys.image1s && commoditys.image1s.length>0">
        <swiper-slide v-for="(item,index) in commoditys.image1s" :key="item.imageUrl">
          <img
            class="swipe-img"
            :style="{'width':windowRatio * imagesRatio[index].width + 'px', 'height':windowRatio * maxhegint + 'px'}"
            :src="item.imageUrl+'?x-oss-process=style/style_detail_banner_img'"
            @click="showImg(index)" object-fit="cover"
          >
          <van-image
            v-if="commoditys.goodsActivityInfo && commoditys.goodsActivityInfo.frameImageUrl &&index==0"
            @click="showImg(index)"
            class="swipe-back"
            :src="commoditys.goodsActivityInfo && commoditys.goodsActivityInfo.frameImageUrl"
          />
        </swiper-slide>
        <div class="swiper-pagination" v-if="swiperOption.autoplay" slot="pagination"></div>
      </swiper>
      <!--秒杀  -->
      <div class="index-product-seckill" v-if="commoditys.seckillType==1">
        <div class="index-seckill-price">
          <div class="index-seckill-backs">
            <img src="https://img.chinabeego.com/uploadfile/2021/5/6/16202832366489252124745656932.png" />
          </div>
          <div class="seckill-price-left">
            <div class="row">
              <div class="left">
                <span class="symbol">￥</span>
                <span class="price">{{commoditys.seckillPrice}}</span>
              </div>
              <div class="right">
                <span class="tag">秒杀价</span>
                <span class="tag qw-vip" v-if="commoditys.switchUserGroup === 2">企微会员专享</span>
              </div>
            </div>
            <div class="row bottom">
              <div class="left" v-if="commoditys.markingPrice">
                <span class="marking-price">￥{{commoditys.markingPrice}}</span>
              </div>
              <div class="right" v-if="commoditys.discountStr && commoditys.discountStr !='0折'">
                <span class="tag">{{commoditys.discountStr}}</span>
              </div>
            </div>
          </div>
          <div class="seckill-price-right">
            <div class="contents">距优惠结束</div>
            <div class="timer">
              <p v-if="commoditys.surplusTime.day!='00'">
                <span>{{commoditys.surplusTime.day}}</span>天
              </p>
              <p>
                <span>{{commoditys.surplusTime.hour}}</span>时
              </p>
              <p>
                <span>{{commoditys.surplusTime.minute}}</span>分
              </p>
              <p v-if="commoditys.surplusTime.day=='00'">
                <span>{{commoditys.surplusTime.second}}</span>秒
              </p>
            </div>
          </div>
        </div>
        <div class="index-seckill-title">
          <div class="title"><span class="shop_tips" v-if="commoditys.goodsActivityInfo && commoditys.goodsActivityInfo.goodsMark">{{commoditys.goodsActivityInfo.goodsMark}}</span>{{commoditys.itemName}}</div>
          <div class="share"  @click="onClickIcon('follw')">
                  <van-image :src="isfollw?herat:noherat" width="20px" height="20px" />
                  <span>关注</span>
            </div>
        </div>
        <van-popup class="seckill-coupon-container" v-model="seckillStatus" round position="bottom">
          <div class="seckill-coupon-title">促销优惠</div>
          <div
            class="seckill-coupon-lists"
            v-for="(item, index) in commoditys.promotionDescriptions"
            :key="'seckill'+index"
          >
            <div class="title">
              <span v-if="item.type==1">秒杀</span>
              <span v-if="item.type==2">商品折扣</span>
              {{item.description}}
            </div>
            <div class="timer" v-if="item.type==1">{{item.timeInterval}}</div>
          </div>
        </van-popup>
      </div>
      <!--   -->
      <div class="index-product-yugao" v-if="commoditys.seckillType==2">
        <div class="product-yugao-price">
          <div class="seckill-price-lefts">
            <div class="price">
              <span style="color: #ED3939;">
                <i>￥</i>
                {{commoditys.price}}
              </span>
               <p class="markingPrice">￥{{commoditys.markingPrice}}</p>
               <p class="discountStr" v-if="commoditys.discountStr" style="color: #ED3939; background-color: #FFEDEE;">{{commoditys.discountStr}}</p>

              <img v-if="commoditys.price != commoditys.markingPrice" src="@/assets/home/_prcent@2x.png" />
            </div>
          </div>
          <div class="index-seckill-title">
            <div class="share"  @click="onClickIcon('follw')">
                  <van-image :src="isfollw?herat:noherat" width="20px" height="20px" />
                  <span>关注</span>
            </div>
          </div>
        </div>
        <div class="product-yugao-tips">
          <span>秒杀预告</span>
          {{commoditys.seckillDate}} 秒杀价 ￥{{commoditys.seckillPrice}}
          <p
            @click="onSeckillTixing(commoditys.isSetSeckillRemind)"
            v-if="!commoditys.isSetSeckillRemind"
          >提醒我</p>
          <p
            @click="onSeckillTixing(commoditys.isSetSeckillRemind)"
            v-if="commoditys.isSetSeckillRemind"
          >取消提醒</p>
        </div>
      
      </div>
      <div class="index-product-yugao" v-if="commoditys.seckillType==0">
        <!-- v-if="commoditys.discountComerMarkVO&&commoditys.discountComerMarkVO.activityId" -->
        <div class="index-discount-wrap" v-if="commoditys.goodsActivityInfo&&commoditys.goodsActivityInfo.id" style="margin-bottom:10px">
          <template v-if="commoditys.goodsActivityInfo.goodsActivityStyle">
            <img class="back" :src="commoditys.goodsActivityInfo.goodsActivityStyle.imageBgPriceUrl?commoditys.goodsActivityInfo.goodsActivityStyle.imageBgPriceUrl:'../../assets/image/disocunt_back@2x.png'" />
            <div class="index-discount-left">
              <div class="txtLabel" :style="{'color':commoditys.goodsActivityInfo.goodsActivityStyle.colorLabel}">{{commoditys.goodsActivityInfo.goodsActivityStyle.txtLabel}}</div>
              <div :style="{'color':commoditys.goodsActivityInfo.goodsActivityStyle.colorPrice}"> 
                <span >￥</span>
                <span  class="price">{{commoditys.price}}</span>
                <span  class="txtLabel" style="margin-left:5px;text-decoration:line-through">￥{{commoditys.markingPrice}}</span>
              </div>
            </div>
            <!-- v-if="commoditys.surplusTime.day==0" -->
            <div class="index-discount-right" >
              <div class="ifo" :style="{'color':commoditys.goodsActivityInfo.goodsActivityStyle.colorCountDownTips}">距结束还剩</div>
              <div class="time">
                <div :style="{'color':commoditys.goodsActivityInfo.goodsActivityStyle.colorCountDownCardFont,'background-color':commoditys.goodsActivityInfo.goodsActivityStyle.colorCountDownCard}">{{commoditys.surplusTime.day}}</div>
                <span >天</span>
                <div :style="{'color':commoditys.goodsActivityInfo.goodsActivityStyle.colorCountDownCardFont,'background-color':commoditys.goodsActivityInfo.goodsActivityStyle.colorCountDownCard}">{{commoditys.surplusTime.hour}}</div>
                <span >时</span>
                <div :style="{'color':commoditys.goodsActivityInfo.goodsActivityStyle.colorCountDownCardFont,'background-color':commoditys.goodsActivityInfo.goodsActivityStyle.colorCountDownCard}">{{commoditys.surplusTime.minute}}</div>
                <span>分</span>
              </div>
            </div>
          </template>
          <!-- <div class="index-discount-right center" v-else>
            <div>{{commoditys.discountComerMarkVO.startTime.split(' ')[0]}}~{{commoditys.discountComerMarkVO.endTime.split(' ')[0]}}</div>
          </div> -->

        </div>
        <!--普通商品显示窗口-->
        <div class="product-yugao-price" v-if="!commoditys.goodsActivityInfo">
          <div class="seckill-price-lefts">
            <div class="price">
              <span style="color: #ED3939;">
                <i>￥</i>
                {{commoditys.price}}
              </span>
              <p class="markingPrice"  style="color: #999999;">￥{{commoditys.markingPrice}}</p>
              <p class="discountStr"  style="color: #ED3939; background-color: #FFEDEE;" v-if="commoditys.discountStr">{{commoditys.discountStr}}</p>
              <img src="@/assets/home/_prcent@2x.png" />
            </div>

          </div>
          <div class="index-seckill-title ">
            <div class="share"  @click="onClickIcon('follw')">
                  <van-image :src="isfollw?herat:noherat" width="20px" height="20px" />
                  <span>关注</span>
            </div>
          </div>
        </div>
       
      </div>
      <!-- 券 -->
      <div class="index-index-active" v-if="($route.query.type != 'bees' && commoditys.goodsTagList && commoditys.goodsTagList.length != 0) ||commoditys.goodsActivityInfo">
        <!-- <div class="index-branch-label" v-if="commoditys.goodsActivityInfo && commoditys.goodsActivityInfo.goodsMark">{{commoditys.goodsActivityInfo.goodsMark}}</div> -->
        <div
          class="index-index-coupon"
          @click="frightListVisibleFun"
          v-if="$route.query.type != 'bees' && commoditys.goodsTagList && commoditys.goodsTagList.length != 0"
        >
          <div class="index-coupon-lefts-wrap" v-if="isVirtual == 'n'">
            <div class="index-coupon-lefts">
              <!-- 满减  discount -->
              <span :class="item.type  == 3 ? 'discount' : 'reduction'"
                v-for="(item, index) in commoditys.goodsTagList"
                :key="index"
                v-show="index<2"
              >{{item.tag}}</span>
            </div>
          </div>
          <div class="index-coupon-right" v-if="isVirtual == 'n'">
            <img src="../../assets/image/coupon_get_icon@2x.png" />
          </div>
        </div>
      </div>
      <!-- 商品名称 -->
      <div class="index-seckill-title" v-if="commoditys.seckillType != 1">
          <div class="title"><span class="shop_tips" v-if="commoditys.goodsActivityInfo && commoditys.goodsActivityInfo.goodsMark">{{commoditys.goodsActivityInfo.goodsMark}}</span> {{commoditys.itemName}}</div>
          <div class="share"  @click="onClickIcon('follw')"  v-if="commoditys.seckillType == 0 && commoditys.goodsActivityInfo">
                  <van-image :src="isfollw?herat:noherat" width="20px" height="20px" />
                  <span>关注</span>
            </div>
        </div>
  <!-- 放入商品正品图 -->
      <div class="details-img" v-for="(item,index) in getHomeContentPageData.componentList"  :key="index" v-show="item.pageType == 7">
        <img   v-for="(items,ids) in item.items" :key="ids" :src="items.imgUrl" />
      </div>


      <div class="index-seckill-sale" @click="seckillStatus=true" v-if="commoditys.seckillType!=0">
        <div class="lefts"><div class="boder">促销</div><span>秒杀</span></div>
        <div class="right">
          <p>{{commoditys.promotionDescriptions && commoditys.promotionDescriptions[0].description}}</p>
        </div>
      </div>
   

      <div class="bees_prefer-main" v-else-if="commoditys.discountComerMarkVO&&commoditys.discountComerMarkVO.activityId">
        <div class="left">
            <div class="tt1">优惠</div>
            <div class="tt2">多买优惠</div>
            <div class="tt3">{{commoditys.discountComerMarkVO.activityName}}</div>
        </div>
        <img src="../../assets/image/dian@2x.png" @click="frightListVisibleFun" />
      </div>
      <div class="bees_prefer-main bees_activity" v-if="commoditys.goodsActivityInfo">
        <div class="left">
            <div class="tt1">活动</div>
            <div class="tt2">HOT</div>
            <div class="tt3">{{commoditys.goodsActivityInfo.description}}</div>
        </div>
        <img src="../../assets/image/arrow_icon@2x.png" @click="goodsActivityVisibleFun" />
      </div>
    </header>
    <div class="details_item">
      <!-- 放入商品正品图 -->
      <!-- <div class="details-img" v-for="(item,index) in getHomeContentPageData.componentList"  :key="index" v-show="item.type == 7">
        <img   v-for="(items,ids) in item.itemList" :key="ids" :src="items.imgUrl" />
      </div> -->


      <div class="details">
		  <!-- v-if="commoditys.isFreeShipping == 'y'" -->
        <div class="p1">
         <span class="tt1">送至</span>  
         <span style="padding-left:18px">广东 深圳 龙华区</span>
		     <span class="freeshipp"  v-if="commoditys.isFreeShipping == 'y'">【包邮】</span> <span class="describe" v-if="commoditys.isFreeShipping == 'y'">请以提交订单时为准</span>
        </div>
      </div>
      <div class="details-p">
        <div class="details-cell" @click="onClickButton">
          <div>
            <span class="tt1">选择</span>
            <span class="custom-title">{{selectedAttrNames}}</span>
          </div>
          <img src="@/assets/image/arrow_icon@2x.png" />
        </div>
      </div>
      <div class="details">
        <div class="details_barnd">
          <div class="img-box">
            <van-image :src="commoditys.logoImage && commoditys.logoImage.imageUrl"/>
          </div>
          <strong>{{commoditys.branchName}}</strong>
        </div>
        <div v-if="!isShareCome" class="see_brand" @click="onClickIcon('brand')">
          <p>进店看看</p>
        </div>
      </div>
    </div>
    <div class="index-product-flex" v-if="productReco.length>=3">
      <div class="index-product-recomm">
        <div class="names">店铺推荐</div>
        <div class="mores" @click="onClickIcon('brand')">
          <span>查看全部</span>
          <img src="@/assets/image/arrow_icon@2x.png" />
        </div>
      </div>

      <div class="details-img" @click="showinfo=true">
        <img :src="commoditys.afterInstructionsDTO&&commoditys.afterInstructionsDTO.oneLineOneColumnUrl" />
      </div>

      <!-- 数量少于12个  -->
      <div class="product-recomm-scroll"  v-if="productReco.length < 12">
        <div 
          class="product-recomm-list"
          v-for="(item, index) in productReco"
          :key="index"
          @click="onJumpProductDetail(item.id)"
          v-show="index<10"
        >
          <div class="recomm-list">
            <div class="image">
              <img :src="item.indexImage.imageStyles[1].imageUrl" alt />
            </div>
            <div class="title">{{item.itemName}}</div>
            <div class="money">￥{{item.price}}</div>
          </div>
        </div>
      </div>
      <!-- 组件大于12个 轮播展示-->
      <div class="swiper_shop" v-else>
        <swiper :options="swipershop" :autoplay="false" :show-indicators="true"  >
          <swiper-slide style="padding-left:8px" >
            <div  class="product-recomm-list"  v-for="(item, index) in productReco" :key="index"  v-show="index < 6"  @click="onJumpProductDetail(item.id)">
              <div class="recomm-list">
                <div class="image">
                  <img :src="item.indexImage.imageStyles[1].imageUrl" alt />
                </div>
                <div class="title">{{item.itemName}}</div>
                <div class="money">￥{{item.price}}</div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide >
            <div  class="product-recomm-list" @click="onJumpProductDetail(item.id)"  v-for="(item, index) in productReco" :key="index"  v-show="index >= 6" >
              <div class="recomm-list">
                <div class="image">
                  <img :src="item.indexImage.imageStyles[1].imageUrl" alt />
                </div>
                <div class="title">{{item.itemName}}</div>
                <div class="money">￥{{item.price}}</div>
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-pagination" v-if="swipershop.autoplay"  slot="pagination"></div>
        </swiper>
      </div>

    </div>
      <div  v-for="(itme,index) in getHomeContentPageData.componentList" :key="index" >
        <div  v-show="itme.pageType == 23" class="goodsDes">
            <img  v-for="(items,ids) in itme.items" :key="ids" :src="items.pageImgUrl" />
        </div>
      </div>

   


    <div class="details_info">
      <div v-if="commoditys.goodsDetailType==1" v-html="commoditys.info" class="html_detail"></div>
      <div v-if="commoditys.goodsDetailType==2 && commoditys.fixedMode">
        <div v-show="commoditys.fixedMode && commoditys.fixedMode.front.length>0">
          <!-- <h3 class="h3">商品正面</h3> -->
          <van-image
            :src="i.imageUrl"
            v-for="(i,idx) in commoditys.fixedMode.front"
            :key="idx"
            width="100%"
          ></van-image>
        </div>
        <div v-show="commoditys.fixedMode && commoditys.fixedMode.back.length>0">
          <!-- <h3 class="h3">商品背面</h3> -->
          <van-image :src="i.imageUrl" v-for="(i,idx) in commoditys.fixedMode.back" :key="idx"></van-image>
        </div>
        <div v-show="commoditys.fixedMode && commoditys.fixedMode.sides.length>0">
          <!-- <h3 class="h3">商品侧面</h3> -->
          <van-image :src="i.imageUrl" v-for="(i,idx) in commoditys.fixedMode.sides" :key="idx"></van-image>
        </div>
        <div v-show="commoditys.fixedMode && commoditys.fixedMode.details.length>0">
          <!-- <h3 class="h3">商品细节</h3> -->
          <van-image :src="i.imageUrl" v-for="(i,idx) in commoditys.fixedMode.details" :key="idx"></van-image>
        </div>
        <div v-show="commoditys.fixedMode && commoditys.fixedMode.brandimg.length>0">
          <!-- <h3 class="h3" style>商品实拍</h3> -->
          <van-image :src="i.imageUrl" v-for="(i,idx) in commoditys.fixedMode.brandimg" :key="idx"></van-image>
        </div>
      </div>
      <!-- <div>
        <img src="./../../assets/image/2.png" alt />
      </div>-->
      <!-- <div>
        <img src="./../../assets/image/3.png" alt />
      </div>-->


      <!-- 增加商场的信息 -->
      <div   v-for="(itme,index) in getHomeContentPageData.componentList" :key="index"  v-show="itme.pageType != 7">
          <div v-show="itme.pageType == 8" class="swiperview">
            <swiper :options="swipershop"  v-if="itme.branchShopPictureInfo">
                <swiper-slide  v-if="itme.branchShopPictureInfo && itme.branchShopPictureInfo.image1Visible ==1">
                   <div class="shopinfo"  v-if="itme.branchShopPictureInfo">
                      <div class="shopname" >
                            <div class="name">{{itme.branchShopPictureInfo.image1Info.imageName}}</div>
                            <div class="addres">地址：{{itme.branchShopPictureInfo.image1Info.imageAddress}}</div>
                        </div>
                        <div ><span class="Navigation" @click="getNavigation">导航</span></div>
                      </div>
                      <div class="shopshow">
                        <img :src="itme.branchShopPictureInfo.image1Info.imageUrl" alt />
                      </div>
                </swiper-slide>
                <swiper-slide  v-if="itme.branchShopPictureInfo && itme.branchShopPictureInfo.image2Visible ==1">
                        <div class="shopinfo"  v-if="itme.branchShopPictureInfo">
                          <div class="shopname" >
                                <div class="name">{{itme.branchShopPictureInfo.image2Info.imageName}}</div>
                                <div class="addres">地址：{{itme.branchShopPictureInfo.image2Info.imageAddress}}</div>
                            </div>
                            <div ><span class="Navigation">导航</span></div>
                          </div>
                          <div class="shopshow">
                            <img :src="itme.branchShopPictureInfo.image2Info.imageUrl" alt />
                          </div>
                  </swiper-slide>

                <div class="swiper-pagination" v-if="swipershop.autoplay"  slot="pagination"></div>
           </swiper>
          </div>
          <div  v-show="itme.pageType == 9">
              <img  v-for="(items,ids) in itme.items" :key="ids" :src="items.imgUrl" />
          </div>
      </div>


 

    
    </div>
    <div class="index-product-flex border">
      <mixedRecoListdata
        ref="mixedReco"
        :headerStatus="true"
        :showStatus="true"
        :mixedRecoParams="mixedRecoParams"
        :paramStatus="true"
      ></mixedRecoListdata>
    </div>
    <!-- v-show="isDisable" -->
    <div class="disable"  v-show="isDisable">该商品已下架，非常抱歉！</div>
    <div class="disable"  v-show="isSellOut">该商品已经售罄</div>
    <div class="toolbar-inner beego-toolbar" v-show="isquick==='y'">
      <van-button color="#F8D541" size="small" round @click="funquickGoods">我想要</van-button>
    </div>
    <van-goods-action  v-if="!loading" v-show="isquick!=='y'" :safe-area-inset-bottom="false">
      <div class="footer-action-goods" v-if="role!=='bees'">
        <div class="left">
          <div class="left-brand" @click="onClickIcon('brand')">
            <img :src="branchIcon" alt />
            <!-- <van-image :src="branchIcon" width="22px" height="22px" /> -->
            <p>店铺</p>
          </div>
          <div class="left-follow" >
            <img :src="car" alt />
            <!-- <van-image :src="isfollw?herat:noherat" width="22px" height="22px" /> -->
            <p>购物车</p>
          </div>
          <div class="left-bees" @click="onClickIcon('bee')" v-if="isVirtual == 'n'">
            <img :src="beesIcon" alt />
            <!-- <van-image :src="beesIcon" width="22px" height="22px" /> -->
            <p>蜜蜂</p>
          </div>
        </div>
        <div class="right" v-if="commoditys.seckillType == 2 && (commoditys.dropcount == 2)">
          <img v-if="commoditys.isSetSeckillRemind" class="remind" @click="onRemainPromt" src="../../assets/image/noremind@2x.png" />
          <img v-else class="remind" @click="onSeckillTixing(commoditys.isSetSeckillRemind)" src="../../assets/image/remind@2x.png" />
        </div>
        <div class="right" v-else>
          <button
            color="#F7BE43"
            class="left_btn"
            :class="{'van-button--disabled':isDisable,isSellOut :'isDisable',isDisable:'isDisable'}"
            :disabled="isDisable"
            @click="onClickButton"
            v-if="isVirtual == 'n'"
          >加入购物车</button>
          <button
            color="#F8D541"
            class="right_btn"
            :class="{'van-button--disabled':isDisable,isSellOut :'isDisable',isDisable:'isDisable'}"
            :disabled="isDisable"
            @click="onClickButton"
          >立即购买</button>
        </div>
      </div>
    </van-goods-action>
    
    <van-action-sheet v-model="showinfo">
      <div class="sheep_contentt">
        <img :src="commoditys.afterInstructionsDTO&&commoditys.afterInstructionsDTO.detailsPictureUrl" />
        <!-- <img src="@/assets/brand/2-1.png" v-if="commoditys.isActiveShop==1"/>
        <img src="@/assets/brand/1-1.png" v-else/> -->
        <div class="sheep_content_btn">
          <span class="yellow" @click="showinfo=false;">知道了</span>
        </div>
      </div>
    </van-action-sheet>
    <shareItem v-show="isShareCome || $route.query && $route.query.sharetype =='browser'" pageCode="5010701" v-isNoAppShare/>
    <preferList ref="prefer-list"></preferList>
    <activityDetail v-if="commoditys.goodsActivityInfo" ref="activity-detail" :info="commoditys.goodsActivityInfo"></activityDetail>
    <goods-sku ref="goods-sku" @select-attrs="onSelectAttrsChange"/>

    <!--反馈按钮 ver1104 -->
    <div class="feedback-item" v-if="readFeedBack" @click="feedHandler">
      <div class="icon"></div>
    </div>

  </div>
</template>
<script>
import http from "@/utils/axios";
import utils from "@/utils/common";
import ListItem from "@/views/coupon/components/receive";
import searchDiscover from "@/views/shareDiscovery/components/itemContent.vue";
import mixedRecoListdata from "@/components/mixedReco/mixedRecoListdata";
import shareItem from '@/views/shareDiscovery/components/shareBtn';
import preferList from '@/components/coupon/prefer-list';
import activityDetail from '@/components/coupon/activity-detail';
import GoodsSku from '@/components/goodsSku';
export default {
  data() {
    return {
      herat: require("@/assets/image/herat.png"),
      noherat: require("@/assets/image/herat1.png"),
      beesIcon: require("@/assets/image/bee.png"),
      branchIcon: require("@/assets/image/product.png"),
      car:require("@/assets/image/car.png"),
      seckillStatus: false,
      isShareCome: this.$route.query.share == "1" ? true : false,
      userId: this.$route.query.userId || "",
      commoditys: {
        couponTagList: []
      },
      showLoading: true,
      current: 0,
      isquick: "n",
      isVirtual: "n",
      imageLength: 3,
      sku: {},
      imags: "",
      commodityId: "",
      stepperValue: 1,
      show: false,
      showinfo: false,
      isfollw: false,
      attrs: {},
      isDisable: false,
      isSellOut:false,
      queryData: {},
      attrsValues: [],
      imagesRatio: [],
      swiperOption: {
        autoplay: false,
        speed: 1000,
        loop: true,
        pagination: {
          el: ".swiper-pagination"
        },
        autoHeight: true
      },
      swipershop: {
        autoplay: true,
        // speed: 1000,
        // loop: true,
        pagination: {
          el: ".swiper-pagination"
        },
        // autoHeight: true
      },

      stockData: {},
      productSetTimer: null,
      frightListVisible: false,
      couponList: [],
      gioObj: {
        entryShape_var: "商品详情模块",
        entryPage_var: document.title,
        functionName_var: "联系蜜蜂",
        primarySort_var: "",
        secondSort_var: "",
        thirdSort_var: "",
        fourthSort_var: "",
        brand_var: "",
        productName_var: ""
      },
      discoverReco: [],
      productReco: [],
      mixedRecoParams: {},
      selected: { names: '', checked: false },
      windowRatio: window.innerWidth / 750,
      maxhegint: '' ,   //最大商品的高度
      getHomeContentPageData:{},
      role:'',
      loading: true,
      selectedAttrNames: '',
      readFeedBack:null,   //控制反馈按钮 显示/隐藏  ver1104
    };
  },
  methods: {
    //接口请求 ver1104
    getFeedBackInfo() {
      // let params={}
      console.log("rps--taskQualifications-this.$route.query--",this.$route.query);
      //bees:蜜蜂角色色
      if(this.$route.query&&this.$route.query.role == "bees"){
        http({
          url: "/order/bizGoodsTask/taskQualifications/" + this.commodityId +"/STAFF",
          method: "get",
          //parmes: params,
        })
          .then((rps) => {
            console.log("rps--taskQualifications---",rps);
            if (rps.code == 200 && rps.data) {
              this.$set(this, "readFeedBack", rps.data);
            }
          })
          .catch((rps) => {});
      }
    },
    feedHandler(){
      let tp={ "goodsId":this.commodityId,"goodsName":this.commoditys.itemName,"goodsPrice":this.commoditys.price,"markingPrice":this.commoditys.markingPrice}
      console.log("tp---feedHandler-----",tp);
      utils.nativeMethod({"tm":3060102,"tp":tp});
    },
    // 获取商品正品 、 商场 、 详情杰介绍图  ( 没有传入值)
    getHomeContent(){
      let httpObj = {}
      let data = localStorage.getItem('homedata');
      let homedata = data && JSON.parse(data) || {}
      let {linkId, preview, dateTimeString, terminal, version ,id} = this.$route.query;
      if(linkId) {
        httpObj.url = 'order/admin/content-page/getContentPage';
        httpObj.method = 'post';
        httpObj.parmes = {
          contentPageId:linkId,
          goodsId:id
        }
      } else if(preview) {
        httpObj.url = 'order/admin/content-page/previewContentPage';
        httpObj.method = 'post';
        httpObj.parmes = {
          currentDateTimeString: dateTimeString,
          terminal,
          version,
          type:3,
          goodsId:id
        }
      } else {
        let temp = this.formartListIdFun(id);
        httpObj.url = 'order/app/new/content-page/getHomeContentPageData';
        httpObj.method = 'post';
        httpObj.parmes = {
          // contentPageId: homedata.id || '' ,
          // contentPageId: '' ,
          // updateTime: homedata.updateTime || 0 ,
          type:3,
          goodsId: temp
        }
      }
      http(httpObj).then(rps => {
          if (rps.code === 200) {
           this.getHomeContentPageData = rps.data;
           this.$loading.hide();
          }
        }).catch(err=>{
          this.$loading.hide();
        });
    },
    /**
     * 针对传过来的id 是 xx:xx:xx 这种格式 
     * 则格式化成取最后一个值
     */
    formartListIdFun(id){
      let temp = id;
      if(id.indexOf(":") != -1){
        let arr = id.split(":");
        temp = arr[arr.length - 1];
      }
      return temp;
    },
    getNavigation(){
      this.$minicode.show({pageCode:5010701,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
    },
    goodsActivityVisibleFun() {
      this.$refs['activity-detail'].onPopupChange()
    },
    onImageLoad(images) {
      var  maxhegint = 0;
      this.imagesRatio = images.map(image=>{
        return this.getImageComputed(image)
      })

      console.log('输出的图片', this.imagesRatio)
      // 求出最大的高度设置盖度
      this.imagesRatio.forEach(itme=>{
        console.log('itme.height',itme.height,maxhegint)
        if(itme.height > maxhegint){
          maxhegint = itme.height
        }  
      })
      this.maxhegint = maxhegint;
      console.log('得到的高度是',maxhegint)

    },
    getImageComputed(image) {
      console.log(image)
      let imageRatio = {}
      if(!image.imageWidth || !image.imageHeight) {
        // return {
        //   width: undefined,
        //   height: undefined
        // }
       return {
          width: 750,
          height: 1000
        }

      }
      if(((image.imageWidth > 750) && (image.imageHeight > 1000))) {
        if((image.imageHeight / 1000) > (image.imageWidth / 750)) {
          imageRatio.width = (image.imageWidth / image.imageHeight * 1000).toFixed(0)
          imageRatio.height = 1000
        } else {
          imageRatio.width = 750
          imageRatio.height = (image.imageHeight / image.imageWidth * 750).toFixed(0)
        }
      } else if(image.imageHeight > 1000) {
        imageRatio.width = (image.imageWidth / image.imageHeight * 1000).toFixed(0)
        imageRatio.height = 1000
      } else if((image.imageWidth <= 750) && (image.imageHeight <= 1000)) {
        imageRatio.width = image.imageWidth;
        imageRatio.height = image.imageHeight;
      } else {
        imageRatio.width = 750
        imageRatio.height = (image.imageHeight / image.imageWidth * 750).toFixed(0)
      }
      return imageRatio
    },
    onClickIcon(type) {
      let that = this
      this.$minicode.show({pageCode:5010701,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      if (this.commoditys && this.commoditys.id) {
        switch (type) {
          case "brand":
            utils.jumpToNewPage({
              url:
                location.origin +
                "/h5user/brandindex?id=" +
                this.commoditys.branchNo,
              noTitle: "1",
              barColor: "#FFFFFF",
               action:{tm:"4090100",tp:{branchId:parseInt(this.commoditys.branchNo)}}
            });
            break;
          case "follw":
            this.follw();
            break;
          case "bee":
            this.gioObj.brand_var = this.commoditys.branchName;
            this.gioObj.productName_var = this.commoditys.itemName;
            utils.easemobBees(this.commoditys.branchNo, this.commoditys.id);
            that.$publicFunc.getJumpSingeOrTeam({
              statusParmes: {
                branchId: that.commoditys.branchNo
              },
              teamParmes: {
                branchId: that.commoditys.branchNo
              },
              callback: function (status, teamDetail) {
                utils.beeChatGioReport({
                  gio: that.gioObj,
                  business: {
                    branchId: that.commoditys.branchNo,
                    goodsId: that.commoditys.id,
                    key: "easemob",
                    teamChatId: status.isTeamChat && teamDetail.teamChatId ? teamDetail.teamChatId : ""
                  }
                });
              }
            })
            break;
          default:
            break;
        }
      }
    },
    follw() {
      this.$minicode.show({pageCode:5010701,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      let msg = this.isfollw ? "取消关注" : "关注成功";
      http({
        url: "item/app/item/follow/" + this.commoditys.id,
        method: "put"
      }).then(rps => {
        if (rps.code === 200) {
          this.$toast(msg);
          // this.$notify({ type: "success", message: "关注成功" });
          this.isfollw = !this.isfollw;
        } else {
          this.$notify({ type: "warning", message: rps.message });
        }
      });
    },
    //  获取详情
    getDetails() {
      (this.commodityId = this.$route.query.id
        ? this.$route.query.id
        : this.$route.query.commodityId)
        if(!this.commodityId){
          return 
        }
        let temp = this.formartListIdFun(this.commodityId);
        this.loading = true;
        http({
          url: "item/app/item/" + temp,
          method: "get"
        }).then(rps => {
          if (rps.code === 200) {
            clearInterval(this.productSetTimer);
            rps.data.surplusTime = {
              day: "00",
              hour: "00",
              minute: "00",
              second: "00"
            };
            if (rps.data.seckillType == 1) {
              this.setDTimeOut(rps.data.seckillRemainTime, rps)
            } else if(rps.data.goodsActivityInfo&&rps.data.goodsActivityInfo.endTime) {
              this.setDTimeOut( new Date(rps.data.goodsActivityInfo.endTime).valueOf(), rps)
            }

            // else if(rps.data.discountComerMarkVO&&rps.data.discountComerMarkVO.endTime) {
            //   this.setDTimeOut(rps.data.discountComerMarkVO.endTime, rps)
            // }
            
            this.isVirtual = rps.data.isVirtual;
            this.isquick = rps.data.isQuick;
            
            this.isfollw = rps.data.isFollow;
            this.mixedRecoParams = rps.data.recommends
              ? rps.data.recommends
              : {};
            
            this.commoditys = rps.data;
       
            // this.onDiscoverRecomm();
            this.onProductRecomm(rps.data.branchNo);
            this.$refs.mixedReco.onGetMixedRecoData();
            if((this.commoditys.image1s || []).length > 1) {
              this.swiperOption.autoplay = {
                delay: 3000,
                disableOnInteraction: false //true 手指触摸之后不再自动轮播 false 反之
              }
            } else {
              this.swiperOption.loop = false
              this.swiperOption.autoplay = false
            }
            let imgs = [];
            this.commoditys.image1s.forEach(item => {
              imgs.push(item.imageUrl);
            });
            this.onImageLoad(this.commoditys.image1s)
            this.imags = imgs;
            this.imageLength = this.commoditys.image1s.length;
            this.isDisable = rps.data.isDisable;
            this.isSellOut =rps.data.isSellOut;
            this.isActiveShop = rps.data.isActiveShop;
          }
        }).finally(() => {
          this.loading = false;
          this.$loading.hide();
        })
    },
    setDTimeOut(timeLong, rps) {
      this.productSetTimer = setInterval(function() {
        var nowsTimeLong = new Date().valueOf();
        var surplusTimeLong = timeLong - nowsTimeLong;
        var day = Math.floor(surplusTimeLong / (1000 * 60 * 60 * 24));
        var hour = Math.floor((surplusTimeLong / (1000 * 60 * 60)) % 24 );
        var minute = Math.floor((surplusTimeLong / (1000 * 60)) % 60);
        var second = Math.floor((surplusTimeLong / 1000) % 60);
        var surplusTime = {
          day: day < 9 ? "0" + day : day,
          hour: hour < 9 ? "0" + hour : hour,
          minute: minute < 9 ? "0" + minute : minute,
          second: second < 9 ? "0" + second : second
        };
        // console.log('surplusTime',surplusTime)
        if (surplusTimeLong <= 0) {
          clearInterval(this.productSetTimer);
        }
        rps.data.surplusTime = surplusTime;
      }, 1000);
    },
    onDiscoverRecomm() {
      (this.commodityId = this.$route.query.id
        ? this.$route.query.id
        : this.$route.query.commodityId),
        http({
          url: "discover/appuser/beesdiscover/findRandomContent",
          method: "post",
          parmes: {
            goodsId: this.$route.query.id
          }
        }).then(rps => {
          if (rps.code === 200) {
            this.discoverReco = rps.data;
          }
        });
    },
    onProductRecomm(branchid) {
      http({
        url: "order/app/item/findGoodsListInGoodsDetail/" + branchid,
        method: "get",
        parmes: {}
      }).then(rps => {
        if (rps.code === 200) {
          this.productReco = rps.data;
        }
      });
    },
    onJumpProductDetail(productid) {
      // this.$router.push({ path: "/commoditydetails", query: { id: productid } });
      var obj = {goodsId:parseInt(productid)};
      utils.jumpToNewPage({
        url:
          window.location.origin + "/h5user/commoditydetails?id=" + productid,
          noTitle: "0",
          action:{tm:"4030100",tp:obj }
      });
    },
    onRemainPromt() {
      this.$toast("在开抢前五分钟会提醒你哦！");
    },
    onSelectAttrsChange(selected) {
      this.selectedAttrNames = selected.names;
    },
    onSeckillTixing(seckillFirm) {
      if (!seckillFirm) {
        http({
          url: "order/user/seckill/follow/" + this.commoditys.seckillGoodsId,
          method: "put"
        }).then(rps => {
          if (rps.code === 200) {
            this.$toast("添加提醒成功");
            this.commoditys.isSetSeckillRemind = true;
          }
        });
      } else {
        http({
          url: "order/user/seckill/unfollow/" + this.commoditys.seckillGoodsId,
          method: "put"
        }).then(rps => {
          if (rps.code === 200) {
            this.$toast("已取消提醒");
            this.commoditys.isSetSeckillRemind = false;
          }
        });
      }
    },
    onClickButton() {
      console.log("onClickButton--1~ver0217--newdetails组件~");
      if(process.env.NODE_ENV === 'production') {
        this.$minicode.show({pageCode:5010701,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      }
      if (this.isShareCome) {
        return;
      }
      if(this.role ==='bees'){
        return ;
      }
      this.$refs['goods-sku'].show(this.commoditys);
    },
    // 添加购物车
    addCart() {
      this.$minicode.show({pageCode:5010701,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      if(this.stock == 0) {
        return this.$toast('抱歉！该商品已售罄');
      }
      if (this.stepperValue > this.attrs.stock) {
        return this.$toast("该商品库存不够");
      }
      if (this.attrs.stock <= 0) {
        return this.$toast("该商品暂无库存");
      }
      if(!this.selected.checked) {
        return this.$toast("抱歉！请选择完一组规格");
      }
      http({
        url: "item/shoppingCart/add",
        method: "post",
        parmes: {
          goodId: this.$route.query.id || this.$route.query.commodityId,
          count: this.stepperValue,
          skuId: this.attrs.skuId
        }
      }).then(rps => {
        if (rps.code === 200) {
          utils.updateCarNum(
            this.$route.query.id || this.$route.query.commodityId
          );
          this.$toast({
            message: "添加购物车成功",
            icon: "cart-o"
          });
        } else {
          this.$toast(rps.message);
        }
      });
    },
    // 立即购买
    sumbit() {
      this.$minicode.show({pageCode:5010701,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      if(this.stock == 0) {
        return this.$toast('抱歉！该商品已售罄');
      }
      if (this.attrs.stock <= 0) {
        return this.$toast("该商品暂无库存");
      }
      if(!this.selected.checked) {
        return this.$toast("抱歉！请选择完一组规格");
      }
      console.log("onClickButton--1~ver0217--newdetails组件~",this.stockData);
      if(this.stockData.limitPurchaseRemind) { //秒杀限购提示
        return this.$toast(this.stockData.limitPurchaseRemind)
      }
      http({
        url: "base/user/user/",
        method: "get"
      }).then(rps => {
        console.log("rps:--1~ver0217---",rps);
        if (rps.code === 200) {
          this.stockData.commodityId =
            this.$route.query.id || this.$route.query.commodityId;
          this.stockData.count = this.stepperValue;
          this.stockData.limitPurchaseNum = this.commoditys.limitPurchaseNum;
          gio("track", "directOrder", {
            productID_var: this.stockData.commodityId,
            brand_var: this.commoditys.branchName,
            productName_var: this.commoditys.itemName
          });
          let pageUrlName = this.commoditys.isVirtual == 'y' ? '/virtualSureOrder' : '/sureOrder' 
          console.log("pageUrlName--1~ver0217--",pageUrlName);
          this.$router.push({
            path: pageUrlName,
            query: {
              seckillSkuId: this.stockData.seckillSkuId
                ? this.stockData.seckillSkuId
                : "",
              goodsId: this.stockData.goodId,
              skuId: this.stockData.id,
              count: this.stockData.count
            }
          });
        }
      }).catch((err)=>{
          console.log("err---1~ver0217--",err);
      });
    },
    showImg(index) {
      console.log(index)
      utils.showMaxImg(
        window.encodeURIComponent(JSON.stringify(this.imags)),
        index
      );
    },
    shareGoods() {
      this.$minicode.show({pageCode:5010701,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      utils.shareGoods("", "", "", "", "goods", this.commoditys.id);
      utils.nativeMethod({tm:'3060101',tp:{branchName:this.commoditys.branchName,branchId:this.commoditys.branchNo,goodsId:this.commoditys.id}})
    },
    onChange(index) {
      this.current = index;
    },
    funquickGoods() {
      let id = this.commodityId;
      utils.quickGoodsCallBack(id);
    },
    frightListVisibleFun() {
      this.$minicode.show({pageCode:5010701,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      this.$refs['prefer-list'].onPreferShow({
        itemGoodsId: this.$route.query.id || this.$route.query.commodityId,
        goodType: 1
      }, 3);
    },
    getGoodscategory() {
      this.commodityId = this.$route.query.id
        ? this.$route.query.id
        : this.$route.query.commodityId;
      if(!this.commodityId){
        return ;
      }
      let temp = this.formartListIdFun(this.commodityId);
      this.http({
        url: "order/app/item/findgoodscategory/" + temp,
        method: "get"
      }).then(rps => {
        if (rps.code === 200) {
          this.gioObj.primarySort_var = rps.data.categoryLevel1;
          this.gioObj.secondSort_var = rps.data.categoryLevel2;
          this.gioObj.thirdSort_var = rps.data.categoryLevel3;
          this.gioObj.fourthSort_var = rps.data.categoryLevel4;
        }
      });
    },
    doc(event){
      console.log(event,'12312123');
    }
  },
  created() {
    this.role = this.$route.query.role
    this.getDetails();
    this.getGoodscategory();
    this.getHomeContent();
    this.getFeedBackInfo()  //调用函数  ver1104
    // let appVersion = window.tools.getversion();
    // if(appVersion ==''){
    //   this.isShareCome = true;
    // }
    utils.nativeMethod({ tm: "4000101", tp: { module_evar: "商品详情页" } });
    utils.nativeMethod({
      tm: "4000102",
      tp: { pageName_pvar: document.title }
    });
    utils.nativeMethod({ tm: "4000102", tp: { pageType_pvar: "商品详情页" } });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  components: {
    ListItem,
    "com-search-discover": searchDiscover,
    mixedRecoListdata,
    shareItem,
    preferList,
    activityDetail,
    GoodsSku
  }
};
</script>
<style lang="less" scoped>
.details-img{border-top: 20px solid #f7f7f7;}
.isDisable{background: #CCCCCC;}
.swiperview{height: 543px;}
.txtLabel{font-size: 24px;}
.price{font-size: 48px;font-weight: 500;}
.shop_tips{padding: 10px 20px;text-align:center ; background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%); border-radius: 10px;color: #fff;font-size: 24px;}
.boder{width: 50px;display: inline-block; font-weight: 500;color: #333333;}
.Navigation{ display: inline-block; width: 120px; height: 60px; line-height: 60px; background: #FFFFFF; text-align: center; border-radius: 32px;
  border: 1px solid #999999; font-size: 24px;color:#999999;}
.shopinfo{border-top: 20px solid #f7f7f7;display: flex;justify-content: space-between; padding-top:15px;padding-bottom: 15px;
}
.name{font-size: 28px;font-weight: bold;}
.addres{color: #999;font-size: 22px; white-space: nowrap; width: 70%;
    text-overflow: ellipsis;
    overflow: hidden}
.goodsDes{padding: 30px;} .goodsDes img{width: 100%;}

.shopshow{height:388px;}
.shopshow img{width: 100%;height: 100%;}

// 满折
.discount{
  background: #ED3939;
  border-radius: 10px;
  color: #fff;
}
// 满减
.reduction{
  background: url(../../assets/image/reduction.png) no-repeat;
  background-size: 100% 100%;
  color: #ED3939;
}
	.freeshipp{
		// font-size: 12px;
		font-weight: bold;
		padding: 2px 10px;
		color: #E83636;
		text-align: center;
		margin-left: 30px;
		border-radius:20px ;
	}
button {
  outline: none;
  border: none;
}
.van-popup--bottom.van-popup--round {
  border-radius: 20px 20px 0 0;
}
.commodity_details {
  position: relative;
  background: #fff;
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .img_box{
    box-sizing: border-box;
    max-height:180px;
    max-width:180px;
  }
  /deep/ .van-button__text {
    color: #000;
  }
  /deep/ .van-action-sheet__close {
    z-index: 1;
  }
  /deep/ .swiper-pagination-bullet {
    background-color: #ffffff;
    border: 1px solid #f8d541;
    width: 15px;
    height: 15px;
    opacity: 1;
  }
  /deep/ .swiper-pagination-bullet-active {
    background-color: #f8d541 !important;
  }
  .swipe_info {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    padding: 40px 30px;
    .item {
      font-size: 24px;
      .span1 {
        color: #ec6666;
        font-size: 36px;
        display: inline-block;
        font-weight: 500;
        .span11 {
          font-size: 24px;
        }
      }
      .span2 {
        font-size: 24px;
        color: #ccc;
        padding: 0 24px;
        display: inline-block;
        text-decoration: line-through;
      }
      .span3 {
        font-size: 22px;
        color: #ed3939;
        background: #ffedee;
        display: inline-block;
        padding: 0 10px;
        border-radius: 10px;
      }
      .p2 {
        font-size: 28px;
        color: #333;
        padding-top: 25px;
        font-weight: 500;
        padding-right: 15px;
      }
      .p3 {
        color: #f8a651;
        font-size: 22px;
      }
      .fx {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #333;
      }
      img {
        width: 44px;
        height: 44px;
      }
      .fx_img {
        text-align: center;
      }
    }
  }
  .details_item {
    .details-p {
      padding: 26px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      color: #999;
      border-top: 10px solid #f7f7f7;
      .details-cell {
        font-size: 24px;
        box-sizing: border-box;
        color: #999;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        img {
          width: 40px;
          height: 40px;
        }
        .custom-title {
          padding-left: 26px;
        }
      }
    }
    .details-img{
       border-top: 10px solid #f7f7f7;
       display: flex;
      align-items: center;
       img{
         width: 100%;
         object-fit: cover;
         max-width: 100%;
       }
    }
    .details {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 24px;
      color: #999;
      padding: 30px;
      border-top: 10px solid #f7f7f7;
      .p1 {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          height: 25px;
          padding: 0 16px 0 26px;
        }
      }
      &:last-child {
        border-bottom: 10px solid #f7f7f7;
      }
      img {
        width: 10px;
        height: 10px;
        vertical-align: middle;
        padding-right: 10px;
      }
      .details_barnd {
        display: flex;
        align-items: center;
        .img-box {
          // border: 2px solid #f2f2f2;
          padding: 10px;
        }
        .van-image {
          display: block;
          width: 116px;
          height: 76px;
        }
        strong {
          color: #000;
          font-weight: 500;
          padding-left: 20px;
        }
      }
      .see_brand {
        p {
          background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
          border-radius: 30px;
          color: #fff;
          font-size: 24px;
          padding: 8px 19px;
        }
      }
    }
  }
  .show_lazy_Image{
    min-height: 100px;
  }
  .details_info {
    padding: 30px;
    img {
      max-width: 100%;
    }
    .h3 {
      font-size: 30px;
      text-align: center;
      color: #333;
    }
  }
  .van-popup {
    overflow-y: hidden;
    max-height: 100%;
  }
  // 购物车弹窗
  .content {
    padding: 20px 0;
    position: relative;
    .header {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 30px;
      .sku_info {
        padding-left: 30px;
        .sku_price {
          color: #ff1c1c;
          font-size: 36px;
          font-weight: bold;
          .size24 {
            font-size: 24px;
          }
        }
        .sku_sum {
          font-size: 24px;
          color: #999;
          padding: 10px 0;
          height: 34px;
        }
        .sku_chekc {
          font-size: 24px;
          color: #333;
          font-weight: 400;
        }
      }
    }
    .sku-box {
      max-height: 60vh;
      overflow-y: auto;
      padding: 0 30px;
    }
    .suk_attribute {
      padding-top: 44px;
      padding-bottom: 50px;
      .attribute_title {
        font-size: 26px;
        color: #333;
        font-weight: 500;
        padding-bottom: 30px;
      }
      .attribute_text {
        display: flex;
        flex-wrap: wrap;
        button {
          display: inline-block;
          min-height: 56px;
          font-size: 24px;
          padding: 0 40px;
          border: 2px solid #979797;
          border-radius: 10px;
          margin: 10px;
          background: #fff;
          box-sizing: border-box;
          text-align: left;
        }
        .active {
          background: #f8d543;
          border-color: #f8d543;
        }
        .disabled {
          background: #F1F1F1;
          border-color: #F1F1F1;
          color: #CCCCCC;
          text-decoration: line-through;
        }
      }
      
    }
    .stepper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 400;
      font-size: 24px;
      padding: 40px 0;
      color: #333;
      /deep/ .van-stepper__minus {
        border-radius: 50%;
        background-color: #f8d541;
      }
      /deep/ .van-stepper__plus {
        border-radius: 50%;
        background-color: #f8d541;
      }
      /deep/ .van-stepper__input {
        background: none !important;
      }
      /deep/ .van-stepper__minus--disabled,
      /deep/ .van-stepper__plus--disabled {
        background-color: #f7f8fa;
      }
      .xg {
        color: #f8a651;
      }
    }
    .footer {
      padding: 30px 30px 50px 30px;
      width: 100%;
      text-align: center;
      font-size: 0;
      box-sizing: border-box;
      .shoppingCart {
        margin-right: 20px;
        background: linear-gradient(90deg, #FFC700 0%, #FF7E00 100%);
      }
      .buyImmediately {
        background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
      }
      button {
        border: 0;
        width: 300px;
        height: 70px;
        font-size: 24px;
        font-weight: bold;
        border-radius: 40px;
        color: #fff;
      }
    }
  }
  .sheep_title {
    font-size: 32px;
    color: #000;
    padding-left: 40px;
    padding-top: 64px;
    padding-bottom: 35px;
  }
  .sheep_contentt {
    padding: 30px 0 0;
    img{
      max-width: 100%;
      object-fit: cover;

    }
    .sheep_content_btn {
      padding: 40px 0;
      text-align: center;
      .yellow {
        background: #f8d541;
        font-size: 32px;
        color: #333;
        padding: 20px 12px;
        width: 250px;
        font-weight: bold;
        border-radius: 50px;
        display: inline-block;
      }
    }
  }
  .popup_content {
    padding: 0.5rem;
    position: relative;
    p {
      margin: 0;
    }
  }
  .disable {
    position: fixed;
    z-index: 99;
    width: 100%;
    left: 0;
    right: 0;
    height: 80px;
    text-align: center;
    background: #FFE7E6;
    
    color: #ED3939;
    font-size: 28px;
    bottom: 100px;
    line-height: 80px;
  }
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    color: #c13c33;
    background: rgba(0, 0, 0, 0.1);
  }
  .van-swipe-item {
    font-size: 20px;
    text-align: center;
  }
  .html_detail {
    font-size: 28px;
    text-align: center;
  }
  .toolbar-inner {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 80px;
    text-align: center;
    background: #fff;
    .van-button {
      color: #333;
      font-weight: 500;
      width: 320px;
      /deep/.van-button__text {
        color: #333;
      }
    }
  }
}
.van-goods-action {
  z-index: 2;
  .footer-action-goods {
    display: flex;
    justify-content: center;
    width: calc(100% - 20px);
    .left {
      flex: 1;
      // width: 300px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      p {
        font-size: 20px;
        color: #333;
      }
      .left-brand {
        text-align: center;
        width: 80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
          display: block;
        }
      }
      .left-follow {
        text-align: center;
        width: 80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 38px;
          height: 38px;
          display: block;
        }
      }
      .left-bees {
        text-align: center;
        width: 80px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
          display: block;
        }
      }
    }
    .right {
      width: 418px;
      text-align: right;
      font-size: 0px;
      button {
        width: 200px;
        height: 70px;
        border-radius: 36px;
        color: #fff;
        display: inline-block;
        font-size: 24px;
        font-weight: bold;
      }
      .left_btn {
        background: linear-gradient(90deg, #FFC700 0%, #FF7E00 100%);
        margin-right: 10px;
      }
      .right_btn {
        background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
      }
      .remind {
        width: 320px;
        height: 70px;
        margin-right: 50px;
      }
    }
  }
}
.share-d {
  width: 100%;
  font-size: 24px;
  position: fixed;
  height: 125px;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  z-index: 10;
  color: #fff;
  .s1 {
    padding-left: 30px;
    padding-right: 30px;
    margin-top: 28px;
    margin-bottom: 26px;
    .s2 {
      padding-left: 29px;
    }
    .s21 {
      display: inline-block;
    }
    .botton {
      border-radius: 0.5rem;
      color: #333;
      font-size: 0.3rem;
      width: 160px;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      margin: 0 10px;
    }
  }
}
.mart {
  padding-top: 26px;
  padding-bottom: 26px;
}
.index-product-seckill {
  display: flex;
  flex-direction: column;
  // margin-top: -15px;
}
.index-seckill-price {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  height: 146px;
}
.index-seckill-backs {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
}
.index-seckill-backs img {
  display: block;
  width: 100vw;
  height: 146px;
  object-fit: cover;
}
.seckill-price-lefts {
  display: flex;
  flex-direction: column;
  z-index: 1;
}
.seckill-price-lefts .price {
  display: flex;
  align-items: center;
  // padding-bottom: 10px;
}
.seckill-price-lefts .price span {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 48px;
  font-weight: 500;
  padding-right: 10px;
}
.seckill-price-lefts .price span i {
  font-size: 24px;
  font-style: normal;
  padding-right: 4px;
}
.seckill-price-lefts .price img {
  display: block;
  width: 91px;
  height: auto;
}
.seckill-price-lefts .marks {
  display: flex;
  align-items: center;
}
.seckill-price-lefts .marks span,.markingPrice {
  color: white;
  font-size: 24px;
  padding-right: 20px;
  text-decoration: line-through;
  // color: rgb(153, 153, 153)
}
.discountStr{margin-right: 10px;}
.seckill-price-lefts .marks p,.discountStr {
  height: 33px;
  line-height: 33px;
  font-size: 22px;
  color: white;
  padding: 0 8px;
  background-color: #DA3E03;
  border-radius: 10px;
}
.seckill-price-left {
  color: #ffffff;
  font-size: 28px;
  z-index: 1;
}
.seckill-price-left .login-tips {
  display: flex;
  align-items: center;
  height: 44px;
  font-size: 22px;
}
.seckill-price-left .symbol {
  font-size: 24px;
}
.seckill-price-left .row {
  display: flex;
}
.seckill-price-left .row .right {
  flex: 1;
  display: flex;
  align-items: center;
}
.seckill-price-left .price {
  font-size: 48px;
  line-height: 1.2;
}
.seckill-price-left .tag {
  background-color: #ffffff;
  color: #ED3939;
  font-size: 22px;
  border-radius: 10px;
  padding: 0 10px;
  margin-left: 10px;
}
.seckill-price-left .qw-vip {
  color: #F8A651;
}
.seckill-price-left .marking-price {
  font-size: 24px;
  text-decoration: line-through;
}
.seckill-price-left .bottom .left {
  display: flex;
  align-items: center;
}

.seckill-price-right {
  display: flex;
  flex-direction: column;
  z-index: 1;
}
.seckill-price-right .contents {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #fff;
  padding-bottom: 20px;
}
.seckill-price-right .timer {
  display: flex;
  align-items: center;
  font-size: 24px;
  color: white;
}
.seckill-price-right .timer p {
  display: flex;
  align-items: center;
}
.seckill-price-right .timer span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 41px;
  height: 33px;
  border-radius: 10px;
  background: rgba(51, 51, 51, 0.5);
  margin: 0 10px;
}
.index-seckill-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 30px;
  // height: 100px;
  background-color: white;
}
.index-seckill-title .title {
  flex: 1;
  padding-right: 45px;
  font-size: 28px;
  font-weight: bold;
}
.index-seckill-title .share {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 65px;

}
.index-seckill-title .share span {
  font-size: 20px;
  // padding-top: 6px;
}
.index-seckill-sale {
  display: flex;
  align-items: center;
  padding: 0 30px;
  height: 80px;
  background-color: white;
  border-top: 10px solid #f7f7f7;
}
.index-seckill-sale .lefts {
  color: #999999;
  font-size: 24px;
  width: 166px;
  display: flex;
}
.index-seckill-sale .lefts span {
  height: 33px;
  width: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: white;
  font-size: 24px;
  background-color: #FF331B;
  margin-left: 44px;
}
.index-seckill-sale .right {
  flex: 1;
  display: flex;
  align-items: center;
}
.index-seckill-sale .right p {
  padding-left: 20px;
  font-size: 24px;
  color: #999999;
}
.seckill-coupon-container {
  max-height: 60%;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.seckill-coupon-title {
  font-size: 32px;
  padding: 36px 0 20px;
}
.seckill-coupon-lists {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 25px 30px;
  border-radius: 10px;
  width: 630px;
  margin-bottom: 20px;
}
.seckill-coupon-lists .title {
  display: flex;
  align-items: center;
  font-size: 26px;
}
.seckill-coupon-lists .title span {
  padding: 0 12px;
  font-size: 24px;
  color: white;
  background-color: #f8a651;
  border-radius: 10px;
  margin-right: 20px;
  height: 33px;
  text-align: center;
}
.seckill-coupon-lists .timer {
  font-size: 24px;
  color: #999999;
  padding-top: 20px;
}
.product-yugao-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 30px;
  padding: 20px 0px 10px 30px;
}
.product-yugao-tips {
  display: flex;
  align-items: center;
  padding: 0 30px;
  font-size: 24px;
  color: #ed3939;
}
.product-yugao-tips span {
  font-size: 22px;
  padding: 0 13px;
  height: 33px;
  border: 2px solid #ed3939;
  line-height: 33px;
  color: #ed3939;
  border-radius: 10px;
  margin-right: 10px;
}
.product-yugao-tips p {
  width: 115px;
  height: 33px;
  text-align: center;
  border-radius: 17px;
  background-color: #f2f2f2;
  font-size: 22px;
  color: #999999;
  margin-left: 10px;
}
.product-yugao-title {
  font-size: 28px;
  font-weight: bolder;
  padding: 20px 30px;
}
.shet {
  display: flex;
  justify-content: center;
  height: 122px;
  line-height: 122px;
  // padding-left: 44px;
  .llef {
    color: #f8a651;
    font-size: 28px;
  }
  .lef {
    font-size: 32px;
    color: 32px;
    // margin-left: 163px;
  }
}
.cont {
  height: calc(50vh - 122px);
  padding: 25px 20px 0 20px;
  background-color: #f7f7f7;
  overflow-y: scroll;
  box-sizing: border-box;
}
.index-index-active {
  display: flex;
  padding: 0 30px 10px;
  // box-sizing: border-box;
  // padding-left: 30px;
  // padding-right: 30px;
  // position: relative;
  // font-size: 0;
  // span {
  //   margin-bottom: 10px;
  // }
  // .index-index-receive {
  //   position: absolute;
  //   top: 0;
  //   right: 30px;
  //   z-index: 10;
  //   width: 114px;
  //   height: 46px;
  // }
}
.index-index-coupon {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.index-coupon-lefts-wrap {
  max-width: 554px;
}
.index-coupon-lefts {
  // width: 300px;
  height: 47px;
  line-height: 47px;
  white-space: nowrap;
  overflow-x: scroll;
  display: flex;
  align-items: center;
  &::-webkit-scrollbar {
    display: none;
  }
}
.index-coupon-lefts span {
  display: inline-block;
  height: 47px;
  line-height: 47px;
  // color: #ed3939;
  font-weight: 400;
  font-size: 24px;
  padding: 0 27px;
  border-radius: 10px;
  // border: 2px solid #ed3939;
  margin-right: 20px;
  box-sizing: border-box;
}
.index-coupon-right {
  width: 115px;
  height: 47px;
  display: flex;
  align-items: center;

  img {
    width: 115px;
    height: 47px;
  }
}
.index-coupon-right i {
  border-width: 22px;
  border-style: solid;
  border-color: transparent #f8a651 transparent transparent;
  width: 0;
  height: 0;
}
.index-coupon-right span {
  padding: 0 20px;
  color: white;
  font-size: 24px;
  height: 47px;
  line-height: 47px;
  background-color: #FF331B;
}

.index-product-flex {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-bottom: 20px solid #f7f7f7;
  /deep/.index-mixed-title {
    padding: 10px 0;
  }
  /deep/.index-mixed-waterfall {
    padding: 0 20px;
  }
  /deep/.index-mixed-lists {
    width: 345px;
  }
}
.index-product-flex.border {
  background-color: #f7f7f7;
  border-bottom: 0;
  padding-bottom: 110px;
}
.index-product-recomm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 30px;
}
.index-product-recomm .names {
  font-weight: bolder;
  font-size: 28px;
}
.index-product-recomm .mores {
  display: flex;
  align-items: center;
}
.index-product-recomm .mores span {
  color: #999999;
  font-size: 24px;
}
.index-product-recomm .mores img {
  width: 40px;
  height: 40px;
}
.product-recomm-scroll {
  display: block;
  width: calc(100vw - 20px);
  padding-right: 20px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.product-recomm-list {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
}
.product-recomm-list .recomm-list {
  display: flex;
  flex-direction: column;
  width: 215px;
  padding-bottom: 20px;
  // height: 310px;
  
}
.product-recomm-list .image img {
  display: block;
  width: 215px;
  height: 215px;
  object-fit: cover;
  border-radius: 10px;
}
.product-recomm-list .title {
  font-size: 24px;
  padding: 10px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  
}
.product-recomm-list .money {
  flex: 1;
  font-size: 24px;
  color: #e83636;
  padding-bottom: 10px;
}
.product-recomm-title {
  display: flex;
  align-items: center;
  padding: 30px;
}
.product-recomm-title span {
  flex: 1;
  border-bottom: 1px solid #dddddd;
}
.product-recomm-title p {
  width: 160px;
  height: 50px;
  border-radius: 50px;
  background-color: #f8d541;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bolder;
}
.index-index-discover {
  display: flex;
  align-items: flex-start;
  padding: 0 10px;
}
.index-discover-between {
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.index-discount-wrap {
  height: 107px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 29px;
  color: #fff;
  padding: 11px 30px;
  position: relative;
  box-sizing: border-box;
}
.index-discount-wrap .back {
  width: 100%;
  height: 107px;
  position: absolute;
  left: 0;
  top: 0;
}
.index-discount-left {
  // display: flex;

z-index: 1;
}
.index-discount-left .tt {
  color: #FFF91B;
}
.index-discount-right {
  height: 85px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
}
.index-discount-right.center {
  justify-content: center;
  div {
    max-width: 300px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 22px;
  } 
}
.index-discount-right .time {
  display: flex;
  font-size: 24px;
}
.index-discount-right .ifo {
  height: 31px;
  font-size: 22px;
  line-height: 31px;
  text-align: center;
}
.index-discount-right .time div {
  width: 41px;
  height: 33px;
  background-color: #e10200;
  border-radius: 10px;
  line-height: 33px;
  text-align: center;
  font-weight: 500;
}
.index-discount-right .time span {
  margin: 0 8px;
}
.bees_prefer-main.bees_activity .left .tt2{
  width: 72px;
  height: 33px;
  line-height: 33px;
  color: #fff;
  font-size: 24px;
  background-color: #ED3939;
}
.bees_prefer-main {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 34px 0 30px;
  border-top: 10px solid #f7f7f7;
  background-color: #fff;
}
.bees_prefer-main .left {
  display: flex;
  align-items: center;
  color: #999;
  font-size: 24px;
}
.tt1{
font-weight: 500;
color: #333333;}
.bees_prefer-main .left .tt2{
  width: 104px;
  height: 28px;
  line-height: 28px;
  border-radius: 10px;
  text-align: center;
  color: #ED3939;
  font-size: 20px;
  background-color: #FFE7E6;
  margin: 0 20px 0 44px;
}
.bees_prefer-main .left .tt3 {
  width: 420px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bees_prefer-main img {
  width: 40px;
  height: 40px;
}
.swipe-img {
  vertical-align: middle;
  // width: 100%;
  object-fit: contain;
  max-height: 1000px;
  
}
.swipe-back {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.index-branch-label {
  display: inline-block;
  height: 47px;
  padding: 0 18px;
  font-size: 24px;
  font-weight: 500;
  line-height: 47px;
  border-radius: 10px;
  background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
  margin-right: 10px;
  white-space: nowrap;
  color: #fff;
}
/deep/ .swiper-container-autoheight .swiper-wrapper {
  background-color: #f7f7f7;
}
.swiper-container-autoheight, .swiper-container-autoheight .swiper-slide {
  text-align: center;
  max-height: 1000px;
  min-height: 562px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7
}

.feedback-item{
  width: 110px;
  height: 110px;
  position: fixed;
  bottom: 150px;
  right: 30px;
  border-radius: 50%;
  overflow: hidden;
  z-index: 1000;
  .icon{
    display: inline-block;
    width: 110px;
    height: 110px;
    position: absolute;
    top: 0;
    left: 0;
    background: url("../../assets/feed-back-icon.png") no-repeat;
    background-size: 100%;
  }
}
</style>
